import { ref } from "vue";

export default function useLoading(defaultStatus: boolean = false) {
  const isLoading = ref(defaultStatus);
  const loadingText = ref("加载中...");
  const showLoading = () => (isLoading.value = true);
  const hideLoading = () => (isLoading.value = false);
  return {
    isLoading,
    loadingText,
    showLoading,
    hideLoading,
  };
}
